"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiSelectOptionsSchema = exports.default = void 0;
var MultiSelectFields_1 = require("./MultiSelectFields");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(MultiSelectFields_1).default; } });
Object.defineProperty(exports, "multiSelectOptionsSchema", { enumerable: true, get: function () { return MultiSelectFields_1.multiSelectOptionsSchema; } });
//# sourceMappingURL=index.js.map